// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Sticky Footer --- */

.spa-sticky-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.75rem 1.5rem;
    display: flex;
    justify-content: center;
    transition: transform 0.25s ease;
    z-index: 999;
    background-color: var(--color-footer-back);
    padding-bottom: env(safe-area-inset-bottom);    
}

    .spa-sticky-footer ul {
        display: flex;
        justify-content: center;
        gap: 1.5rem;
        list-style: none;
        padding: 0;
        margin: 0;
        flex-wrap: wrap;
    }

    .spa-sticky-footer a {
        color: var(--color-footer-fore);
        text-decoration: none;
        font-size: 0.9rem;
    }

        .spa-sticky-footer a:hover {
            color: var(--color-hover-fore);
            text-decoration: underline;
        }

    .spa-sticky-footer.hide {
        transform: translateY(100%);
    }

    .spa-sticky-footer.show {
        transform: translateY(0);
    }

/* Match width rules on large screens */
@media (min-width: 768px) {
    .spa-sticky-footer {
        padding: 1rem 2rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Container/css/SPAStickyFooter.css"],"names":[],"mappings":"AAEA,0BAA0B;;AAE1B;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,YAAY;IACZ,0CAA0C;IAC1C,2CAA2C;AAC/C;;IAEI;QACI,aAAa;QACb,uBAAuB;QACvB,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,+BAA+B;QAC/B,qBAAqB;QACrB,iBAAiB;IACrB;;QAEI;YACI,8BAA8B;YAC9B,0BAA0B;QAC9B;;IAEJ;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;AAEJ,uCAAuC;AACvC;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["@import '../../css/App.css';\r\n\r\n/* --- Sticky Footer --- */\r\n\r\n.spa-sticky-footer {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    padding: 0.75rem 1.5rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    transition: transform 0.25s ease;\r\n    z-index: 999;\r\n    background-color: var(--color-footer-back);\r\n    padding-bottom: env(safe-area-inset-bottom);    \r\n}\r\n\r\n    .spa-sticky-footer ul {\r\n        display: flex;\r\n        justify-content: center;\r\n        gap: 1.5rem;\r\n        list-style: none;\r\n        padding: 0;\r\n        margin: 0;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .spa-sticky-footer a {\r\n        color: var(--color-footer-fore);\r\n        text-decoration: none;\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n        .spa-sticky-footer a:hover {\r\n            color: var(--color-hover-fore);\r\n            text-decoration: underline;\r\n        }\r\n\r\n    .spa-sticky-footer.hide {\r\n        transform: translateY(100%);\r\n    }\r\n\r\n    .spa-sticky-footer.show {\r\n        transform: translateY(0);\r\n    }\r\n\r\n/* Match width rules on large screens */\r\n@media (min-width: 768px) {\r\n    .spa-sticky-footer {\r\n        padding: 1rem 2rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
